import React from 'react';
import { createIcon } from './create-icon';
import './icon-label.scss';

export const IconLabel = createIcon(<div className="icon-label" />);
